<script setup lang="ts">
import { ref, onMounted } from 'vue'
import ClinicListCard from './clinics/ClinicListCard.vue'
import { useUserStore } from '../stores/user'
import GetAppBar from './components/GetAppBar.vue'

const showCard = ref(false)

onMounted(() => {
  setTimeout(() => (showCard.value = true), 300)
})
</script>

<template>
  <v-layout>
    <GetAppBar/>
    
    <v-main>
      <v-slide-y-transition>
        <ClinicListCard v-if="showCard" />
      </v-slide-y-transition>
    </v-main>
  </v-layout>
</template>

<style scoped></style>
